/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  QuotationPrintRequestDto,
  QuotationPrintResponseDto,
  QuoteStructureDetailDto,
  QuoteStructureHeadingDto,
  QuoteStructureItemDto,
  QuoteStructureRequestDto,
  QuoteStructureResponseDto,
} from '@gh/builder-shared-data';
import { coalesce } from '@gh/core-util';
import { map, omit, sortBy } from 'lodash';
import { QuoteStructureRequestItem } from './rfq.model';

export type QuoteStructure = QuoteStructureResponseDto;
export type Heading = QuoteStructureHeadingDto;
export type DetailItem = QuoteStructureDetailDto;
export type QuoteStructureItem = QuoteStructureItemDto;
export type QuoteStructureRequest = QuoteStructureRequestDto;
export type QuoteStructureSelectedObject = {
  heading: Heading;
  item?: QuoteStructureItem;
};
export type QuoteStructurePreviewRequest = QuotationPrintRequestDto;
export type QuoteStructurePreviewResponse = QuotationPrintResponseDto;

export function structureFromDto(structure: QuoteStructure): QuoteStructure {
  return {
    ...structure,
    variations: sortBy(
      map(structure.variations, (variation: QuoteStructureItem) => ({
        ...variation,
        showQty: coalesce(variation.showQty, false),
        showUom: coalesce(variation.showUom, false),
        showPrice: coalesce(variation.showPrice, false),
        hide: coalesce(variation.hide, false),
        details: variation.details || [],
      })),
      'code'),
    headings: map(structure.headings, (heading: Heading) => ({
      ...heading,
      items: heading.items || [],
      details: heading.details || [],
    })),
  };
}

export function structureToDto(structure: QuoteStructure): QuoteStructureRequest {
  return {
    ...structure,
    variations: structure.variations.map((variation: QuoteStructureItem) =>
      <QuoteStructureRequestItem>omit(variation, ['showQty', 'showUom', 'showPrice', 'hide', 'details'])),
  };
}
